import { useRef } from 'react'

import { toCSSPixel } from '../../../../../utils/styles'

import { EMAIL_PROFILE_STICKY_HEADER_HEIGHT_PROPERTY } from './useEmailProfileStickyHeaderHeight.constants'

export function useEmailProfileStickyHeaderHeight({ scrollWrapperRef }) {
  const resizeObserverRef = useRef(null)

  function handleStickyHeaderRef(node) {
    resizeObserverRef.current?.disconnect()
    resizeObserverRef.current = null

    if (node) {
      resizeObserverRef.current = new ResizeObserver(() => {
        scrollWrapperRef.current?.style.setProperty(
          EMAIL_PROFILE_STICKY_HEADER_HEIGHT_PROPERTY,
          toCSSPixel(node.offsetHeight)
        )
      })

      resizeObserverRef.current.observe(node)
    }
  }

  return { handleStickyHeaderRef }
}
